/// <amd-module name="Feed/Core/Redux/Navigation/NavigationReducers" />
import { HubActionStrings } from "Feed/Common/Constants/Constants";
import produce from "immer";

import { NavigationActions, NavigationActionTypes } from "./NavigationActions";
import { IFeedNavigationState } from "./NavigationContracts";

export const navigationReducer = produce((draft: IFeedNavigationState, action: NavigationActions) => {
    switch (action.type) {
        case NavigationActionTypes.HubStateChange:
            draft.hubState = action.payload;
            break;
    }
}, initialFeedNavigationState());

export function initialFeedNavigationState(): IFeedNavigationState {
    return {
        hubState: {
            action: HubActionStrings.ViewFeed,
            feed: undefined,
            package: undefined,
            version: undefined,
            upstreamSource: undefined,
            protocolType: undefined,
            preferRelease: undefined,
            view: undefined
        }
    };
}
